// hooks/use-states.ts
import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { useGetLaunchedStates } from '../../../apis/states/get-launched-states';
import { useDeleteState } from '../../../apis/states/delete-state';

const useStates = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [selectedStateId, setSelectedStateId] = useState("");
    const [isAddingState, setIsAddingState] = useState(false);

    const searchRef = useRef<HTMLInputElement>(null);

    const { data, isFetching: isLoading, refetch } = useGetLaunchedStates({
        page: currentPage,
        search: searchValue,
    });

    const { mutateAsync: deleteState, isPending: isDeletingState } = useDeleteState();

    const states = data?.docs ?? [];
    const totalPages = data?.totalPages ?? 0;

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        setCurrentPage(1);
        if (search) setSearchValue(search);
    };

    const handleClear = () => {
        setSearch("");
        setSearchValue("");
    };

    const handleStateDelete = async () => {
        try {
            await deleteState(selectedStateId);
            toast.success("State Deleted Successfully");
            setSelectedStateId("");
            if (states.length <= 1 && currentPage > 1) {
                setCurrentPage((prev) => prev - 1);
            } else {
                refetch();
            }
        } catch {
            toast.error("Something went wrong, please try again later");
        }
    };

    return {
        states,
        totalPages,
        isLoading,
        isDeletingState,
        currentPage,
        setCurrentPage,
        search,
        setSearch,
        selectedStateId,
        setSelectedStateId,
        isAddingState,
        setIsAddingState,
        searchRef,
        handleSearch,
        handleClear,
        handleStateDelete,
        refetch,
    };
};

export default useStates;